<template>
  <default-layout>
    <event-navbar :title="userDisplay()" />
    <div class="container">
      <hrmine-welcome :first-name="user.first_name" :hints="welcomeHints" />

      <!-- Profile completion nudge: shown only while the profile is incomplete -->
      <div v-if="completionPercent !== null && completionPercent < 100"
           class="card mb-3" :class="'border-' + completionVariant">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <strong>Profil vervollständigen</strong>
            <span class="badge" :class="'bg-' + completionVariant">{{ completionPercent }} %</span>
          </div>
          <div class="progress mb-2" style="height:.75rem">
            <div class="progress-bar" :class="'bg-' + completionVariant" role="progressbar"
                 :style="{ width: completionPercent + '%' }"
                 :aria-valuenow="completionPercent" aria-valuemin="0" aria-valuemax="100"></div>
          </div>
          <p class="text-muted small mb-2">Stärkeres Profil = bessere Kontakte und Empfehlungen.</p>
          <button class="btn btn-sm" :class="'btn-' + completionVariant" @click.prevent="editProfile()">
            Profil bearbeiten <i class="fas fa-arrow-right ms-1"></i>
          </button>
        </div>
      </div>

      <ul class="list-group">

        <li class="list-group-item c-section">Meine Inhalte</li>

        <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
         @click.prevent="recommendations()">
          Für mich empfohlen
          <i class="bi bi-stars text-primary"></i>
        </li>

        <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
         @click.prevent="showFavorites = !showFavorites">
          Favoriten
          <span>
            <span class="badge bg-primary badge-pill me-1">{{ totalFavorites }}</span>
            <i class="fas" :class="showFavorites ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
          </span>
        </li>
        <template v-if="showFavorites">
          <li v-for="(v, k) in favoritesByTitle" :key="k" @click.prevent="routeToFavorites(v)"
            class="list-group-item list-group-item-action d-flex justify-content-between align-items-center ps-4">
            {{ k }}
            <span class="badge bg-primary badge-pill">{{ favorites[favKey(v)]?.length || 0 }}</span>
          </li>
        </template>

        <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
         @click.prevent="userTimeline()">
          Meine Agenda (Timeline)
          <i class="fas fa-calendar-week"></i>
        </li>

        <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
         @click.prevent="meetings()">
          Meetings
          <i class="fas fa-calendar-check"></i>
        </li>

        <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
         @click.prevent="tickets()">
          <b>Tickets</b>
          <i class="fas fa-ticket-alt"></i>
        </li>

        <li class="list-group-item c-section">Kommunikation</li>

        <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
         @click.prevent="contacts()">
          Nachrichten
          <span>
          <span class="badge bg-danger badge-pill me-1"><i class="far fa-envelope"></i> {{ numUnreadMessages }}</span>
          <span class="badge bg-primary badge-pill">{{ directChannels.length || 0 }}</span>
          </span>
        </li>

        <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
         @click.prevent="community()">
          Community
          <i class="fas fa-users"></i>
        </li>

        <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
         @click.prevent="townSquare()">
          Town Square
          <i class="fas fa-comments"></i>
        </li>

        <li v-if="exhibitorInbox.length"
         class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
         @click.prevent="$router.push('/exhibitor-inbox')">
          Aussteller-Postfach
          <span>
            <span v-if="exhibitorInboxUnread" class="badge bg-danger rounded-pill me-1">{{ exhibitorInboxUnread }}</span>
            <i class="fas fa-inbox"></i>
          </span>
        </li>

        <li v-if="exhibitorInbox.length"
         class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
         @click.prevent="$router.push('/exhibitor-recommendations')">
          Aussteller-Kontaktempfehlungen
          <i class="fas fa-user-friends"></i>
        </li>

        <li class="list-group-item c-section">Aussteller</li>

        <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
         @click.prevent="exhibitorScan()">
          <b>Standbesuch erfassen</b>
          <i class="fas fa-qrcode"></i>
        </li>

        <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
         @click.prevent="showVisits()">
          Meine Standbesuche
          <i class="far fa-eye"></i>
        </li>

        <li class="list-group-item c-section">App</li>

        <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
         @click.prevent="$router.push('/about')">
          Über diese App
          <i class="fas fa-info-circle"></i>
        </li>

        <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
         @click.prevent="editProfile()">
          Konto verwalten
          <span>
            <span v-if="completionPercent !== null && completionPercent < 100" class="badge badge-pill me-1"
                  :class="'bg-' + completionVariant">{{ completionPercent }} %</span>
            <i class="fas fa-cog"></i>
          </span>
        </li>

        <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
         @click.prevent="logout()">
          Ausloggen
          <i class="fas fa-sign-out-alt"></i>
        </li>

      </ul>
      <p class="text-small text-muted text-right">App Version: {{ appVersion }}</p>
    </div>
    <!--div class="container">
      <app-rating product="App" />
    </div-->
  </default-layout>
</template>

<script>
import EventNavbar from '@/components/EventNavbar.vue'
import DefaultLayout from '@/components/DefaultLayout.vue'
import FavoriteTitlesMixin from '@/components/lib/favorite-titles-mixin.js'
//import AppRating from '@/components/rating/app-rating.vue'
import HrmineWelcome from '@/components/HrmineWelcome.vue'

export default {
  name: 'UserProfileView',
  //components: {EventNavbar, DefaultLayout, AppRating, HrmineWelcome},
  components: {EventNavbar, DefaultLayout, HrmineWelcome},
  mixins: [FavoriteTitlesMixin],
  data() {
    return {
      user: this.$storage.user,
      favorites: {},
      appVersion: process.env.APP_VERSION,
      initialUnreads: this.$storage.observed.numDirectUnreadMessages,
      observed: this.$storage.observed,
      welcomeHints: {},
      showFavorites: false,
    }
  },

  computed: {
    directChannels() { return this.observed.directChannels },
    numUnreadMessages() {
      return this.observed.numDirectUnreadMessages + this.observed.exhibitorInboxUnread
    },
    completionPercent() {
      const c = this.user && this.user.customer && this.user.customer.completion
      return c ? c.percent : null
    },
    completionVariant() {
      const p = this.completionPercent
      if (p === null) return 'primary'
      if (p >= 90) return 'success'
      if (p >= 50) return 'warning'
      return 'danger'
    },
    exhibitorInbox() { return this.observed.exhibitorInbox },
    exhibitorInboxUnread() { return this.observed.exhibitorInboxUnread },
    totalFavorites() {
      return Object.values(this.favoritesByTitle)
        .reduce((sum, v) => sum + ((this.favorites[this.favKey(v)] || []).length), 0)
    },
  },

  created() {
    this.$storage.fetchUser().then((response) => {
      this.user = response.data
      this.favorites = this.$storage.getFavorites()
    }).catch(error_response => {
      if (error_response.response.status == 403) {
        console.log('redirecting ...')
        localStorage.removeItem('speaker_tool_token')
        this.$router.push('/login')
      }
    })
  },

  mounted() {
    let me = this
    this.$storage.getDirectUnreads().then(() => {
      me.observed = this.$storage.observed
    })
    this.$api.get('/ai-chat/welcome-hints/')
      .then(({ data }) => { this.welcomeHints = data })
      .catch(() => {})
    // Exhibitor inbox comes reactively from the storage (backend-gated to members).
    this.$storage.fetchExhibitorInbox()
  },

  methods: {
    userDisplay() {
      return `${this.user.first_name}  ${this.user.last_name}`.trim() || this.user.username
    },
    favKey(key) {
      return key == 'talk' ? 'favorite_session' : `favorite_${key}`
    },
    routeToFavorites(key) {
      let route = `/user-profile/${key}-favorites`
      this.$router.push(route)
    },
    logout() {
      this.$storage.performLogout()
      this.$router.push('/')
    },
    async editProfile() {
      // Open the (bare) Django account page embedded via IframeView.
      const lang = this.$route.params.lang || 'de'
      // Bridge the SPA token into a Django session first, so the profile page
      // (a session-authenticated Django view) does not force a second login.
      try {
        await this.$api.post('session-login/')
      } catch (e) {
        // Token invalid/expired: fall through -- the profile page then
        // redirects to the normal login as before.
      }
      this.$router.push(`/${lang}/accounts/me/`)
    },
    contacts() {
      this.$router.push('/user-profile/contacts')
    },
    recommendations() {
      this.$router.push('/recommendations')
    },
    community() {
      this.$router.push('/community')
    },
    townSquare() {
      this.$router.push('/channel-town-square')
    },
    userTimeline() {
      this.$router.push('/user-profile/timeline')
    },
    meetings() {
      this.$router.push('/user-profile/meetings')
    },
    tickets() {
      this.$router.push('/user-profile/tickets')
    },
    exhibitorScan() {
      this.$router.push('/user-profile/exhibitor-scan')
    },
    showVisits() {
      this.$router.push('/exhibitors?visits=true')
    }
  }
}
</script>

<style scoped>
/* Non-interactive cluster headers inside the profile menu list. */
.c-section {
  background-color: var(--bs-light, #f8f9fa);
  color: #6c757d;
  font-size: .72rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: .04em;
  padding-top: .4rem;
  padding-bottom: .4rem;
}
</style>
